import React from 'react';

const EyeIcon: React.FC = () => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666504 6.74056C0.666504 6.74056 3.33317 1.40723 7.99984 1.40723C12.6665 1.40723 15.3332 6.74056 15.3332 6.74056C15.3332 6.74056 12.6665 12.0739 7.99984 12.0739C3.33317 12.0739 0.666504 6.74056 0.666504 6.74056Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99984 8.74056C9.10441 8.74056 9.99984 7.84513 9.99984 6.74056C9.99984 5.63599 9.10441 4.74056 7.99984 4.74056C6.89527 4.74056 5.99984 5.63599 5.99984 6.74056C5.99984 7.84513 6.89527 8.74056 7.99984 8.74056Z"
      stroke="#475467"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeIcon;
